export default "__VITE_ASSET__e0628a66__"